import { Slot, SlotSearchParams, GetSlotsResponse } from '../../Model/Slot';
import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { calcRemaining } from './Utils/DateUtil';

export class GetSlotsUseCase {
  constructor(private repo: SlotRepository) {}

  execute(current: User | null, params?: SlotSearchParams, signal?: AbortSignal): Promise<GetSlotsResponse> {
    // SELLER 권한인 경우 user 파라미터 추가
    const searchParams: SlotSearchParams = {
      ...params,
      ...(current && current.grade === 'SELLER' ? { sellerId: current.id } : {})
    };

    return this.repo.getSlots(searchParams, { signal }).then((response) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const processedSlots = response.slots.map((s) => {
        const remaining_days = calcRemaining(s.end_date);

        const endDate = new Date(s.end_date);
        endDate.setHours(0, 0, 0, 0);
        
        // 종료일이 오늘 이전인지 확인
        const isExpired = endDate < today;
        const isToday = endDate.getTime() === today.getTime();
        
        // 상태 결정 로직
        let status = s.status;
        if (s.status === "정상" && isExpired && !isToday) {
          status = "종료";
        } else if (s.status === "연장" && isExpired && !isToday) {
          status = "종료";
        }
        
        return {
          ...s,
          remaining_days,
          status,
        } as Slot;
      });

      return {
        ...response,
        slots: processedSlots
      };
    });
  }
}
